'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var Product_styles = require('../Product.styles-f56712a3.js');
var Product_ProductImage_index = require('./ProductImage/index.js');
var Product_ProductInfoBox_index = require('./ProductInfoBox/index.js');
var Product_PriceRenderer_index = require('./PriceRenderer/index.js');
require('styled-components');
require('../browser.utils-bfcc05c6.js');
require('../viewport.utils-0c2b4e2b.js');
require('../typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var noop = function () { return undefined; };
var Product = function (_a) {
    var isHero = _a.isHero, flexBasisDivisor = _a.flexBasisDivisor, showProductHoverEffect = _a.showProductHoverEffect, children = _a.children, _b = _a.onClick, onClick = _b === void 0 ? noop : _b, _c = _a.onMouseEnter, onMouseEnter = _c === void 0 ? noop : _c, _d = _a.onMouseLeave, onMouseLeave = _d === void 0 ? noop : _d, testId = _a["data-testid"], className = _a.className, props = tslib_es6.__rest(_a, ["isHero", "flexBasisDivisor", "showProductHoverEffect", "children", "onClick", "onMouseEnter", "onMouseLeave", 'data-testid', "className"]);
    return (React__default['default'].createElement(Product_styles.ProductWrapper, tslib_es6.__assign({ isHero: isHero, flexBasisDivisor: flexBasisDivisor, showProductHoverEffect: showProductHoverEffect, onClick: onClick, "data-testid": testId, className: className }, props),
        React__default['default'].createElement(Product_styles.ProductLayout, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, children)));
};

exports.ProductLayout = Product_styles.ProductLayout;
exports.ProductWrapper = Product_styles.ProductWrapper;
exports.ProductImage = Product_ProductImage_index.ProductImage;
exports.ProductImageContainer = Product_ProductImage_index.ProductImageContainer;
exports.ProductImageWrapper = Product_ProductImage_index.ProductImageWrapper;
exports.ProductInfoBox = Product_ProductInfoBox_index['default'];
exports.PriceRenderer = Product_PriceRenderer_index.PriceRenderer;
exports.SpecialPriceRenderer = Product_PriceRenderer_index.SpecialPriceRenderer;
exports.Product = Product;
//# sourceMappingURL=index.js.map
